import { h, render } from 'preact';
import { forwardRef, useRef, useState, useEffect } from 'preact/compat';
import GoogleMapReact from 'google-map-react';
import Marker from './src/Marker';
import MarkerTooltip from './src/MarkerTooltip';
import theme from './src/theme';
import { useAlert } from './src/useAlert';
import { useProjectsApi } from './src/useProjectsApi';

const MapSelectedProjects = node => {
  const center = {
    lat: parseFloat(node.dataset.lat),
    lng: parseFloat(node.dataset.lng)
  }
  const currentPost = {
    title: node.dataset.currentname,
    thumbnail: node.dataset.currentthumbnail
  };

  render(<MapWrapper apiKey={node.dataset.apiKey} defaultCenter={center} zoom={parseInt(node.dataset.zoom)} projectsString={node.dataset.projects} currentPost={currentPost} /> , node);
};

export default MapSelectedProjects;


function MapWrapper(props){
  const { apiKey, defaultCenter, zoom, projectsString, currentPost} = props;

  const selectedProjects = projectsString ? projectsString.split(',') : [];

  const [map, setMap] = useState(null);
  const [renderAlert, setAlert] = useAlert();
  const [center, setCenter] = useState(defaultCenter);
  const [customerLocation, setCustomerLocation] = useState(defaultCenter);
  const [projects] = useProjectsApi(setAlert, selectedProjects);
  const [active_project_index, setActiveProjectIndex] = useState(null);
  const markersRef = useRef([]);

  const onMarkerClick = () => {
      setCenter(customerLocation);
  }

  const handleApiLoaded = (map, maps) => {
    setMap(map);
  };

  useEffect(() => {  
    fitMap();
  }, [map, projects]);

  const fitMap = _ => {
    if (map && projects.length) {
      const bounds = new window.google.maps.LatLngBounds();

      projects.map(project => {
        bounds.extend({
          lat: project.location.latitude,
          lng: project.location.longitude,
        });
      });

      if (customerLocation?.lat) {
          bounds.extend({
            lat: customerLocation.lat,
            lng: customerLocation.lng,
        });
      }

      map.fitBounds(bounds);
    }
  }

  const onProjectMarkerClick = (index, project) => {
    handleProjectClick(index, project);
  }

  const handleProjectClick = (index, project) => {
    setCenter({
        lat: parseFloat(project.location.latitude),
        lng: parseFloat(project.location.longitude)
    });
    setActiveProjectIndex(index);
  }

  const onProjectTooltipClose = () => {
    setActiveProjectIndex(999999);
  }

  const renderProjectMarkers = projects ? projects.map((project, i) => {
    const active = i === active_project_index;

    return (<Marker
      color={active ? '#366d9c' : '#212831'}
      key={i}
      index={i}
      isActive={active}
      ref={el => markersRef.current[i] = el}
      lat={project.location.latitude}
      lng={project.location.longitude}
      project={project} onClick={onProjectMarkerClick}/>)
  }) : null;


  const renderProjectTooltips = projects ? projects.map((project, i) => {
    const active = i === active_project_index;

    return (<MarkerTooltip isActive={active} item={project} lat={project.location.latitude} lng={project.location.longitude} onClose={onProjectTooltipClose} />)
  }) : null;

  return (
    <div className="container">
      <div className="row h-[500px] lg:h-[640px] 2xl:h-[860px]">
        {/*{renderAlert()}*/}

        <div className="w-full h-full">
          <GoogleMapReact
              bootstrapURLKeys={{ key: apiKey }}
              defaultCenter={defaultCenter}
              center={center}
              defaultZoom={zoom ? zoom : 17}
              options={{
                  styles: theme ? theme : []
              }}
              onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
          >
            { customerLocation?.lat ? <Marker color={'#3F82BC'} lat={customerLocation.lat} lng={customerLocation.lng} onClick={_=> { setActiveProjectIndex(null);setCenter({ lat: parseFloat(customerLocation.lat),lng: parseFloat(customerLocation.lng)}); }} /> : null }

            { projects ? renderProjectMarkers : null }
            { projects ? renderProjectTooltips : null }
            { customerLocation?.lat ? <MarkerTooltip isActive={active_project_index === null} item={currentPost} lat={customerLocation.lat} lng={customerLocation.lng} onClose={onProjectTooltipClose} /> : null }
          </GoogleMapReact>
        </div>
      </div>
    </div>
  );
}
